
import LightView from './src/LightView.vue' //设备概览
import LightControl from './src/LightControl.vue' //设备控制
import LightControlConfig from './src/LightControlConfig.vue' //设备控制策略
import LightStatistics from './src/LightStatistics.vue' //数据统计

let views = {

    LightView,
    LightControl,
    LightControlConfig,
    LightStatistics
};

export default views;